import { render, staticRenderFns } from "./cookie-load.vue?vue&type=template&id=8224fea2&"
import script from "./cookie-load.vue?vue&type=script&lang=js&"
export * from "./cookie-load.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports